import type {ReactElement} from 'react';
import React from 'react';
import type {MediaControlsItemProps} from '@Components/contextual-menu/components/media-controls-item';
import {Option} from '@Components/contextual-menu/components/option';
import {MediaControls} from '@Components/contextual-menu/components/media-controls';

interface ContextualMenuMediaControlOptionsProps {
  id: string;
  className?: string;
  items: MediaControlsItemProps[];
  columns?: 2 | 3;

  onClick?(id: string): void;
}

export function ContextualMenuMediaControlOptions({className = '', ...props}: ContextualMenuMediaControlOptionsProps): ReactElement<any> | null {
  return (
    <Option
      key={props.id}
      showControlInCenter
      optionControl={
        <MediaControls
          className={className}
          items={props.items}
          columns={props.columns}
          onClick={(id): void => {
            if (props.onClick) {
              props.onClick(id);
            }
          }}
        />
      }
    />
  );
}
